import {  LoginUrlsWrapper } from '../../app/spaces/Login/LoginUrls';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { ILocLinkifierModel } from '../filters/LocLinkifierFilter';
import { SolrErrorCode } from '../helpers/ErrorCodes';
import { Module } from '../Module';
import { ServerService } from '../services/ServerService';

//Either detailsLocKey or detailsLinkifierModel should be specified in the IErrorStateParams.
//If both are given, detailsLocKey takes precedence.
export interface IErrorStateParams {
  detailsLocKey?: string;
  detailsLinkifierModel?: string; //stringified JSON object because state params must be strings
  redirectState?: string;
  redirectLocKey?: string;
  redirectSiteUrlName?: string;
  errorCode?: any;
}

export interface IErrorScope extends ng.IScope {
  detailsLocKey: string;
  detailsLinkifierModel: () => ILocLinkifierModel;
  redirectUrl: string;
  redirectLocKey: string;
}

export class ErrorCtrl {
  public static StateParamKeys = {
    DetailsLocKey: 'detailsLocKey',
    DetailsLinkifierModel: 'detailsLinkifierModel',
    RedirectState: 'redirectState',
    RedirectLocKey: 'redirectLocKey',
    RedirectSiteUrlName: 'redirectSiteUrlName'
  };

  public static $inject = [
    '$scope',
    '$state',
    '$stateParams',
    'ServerService'
  ];

  constructor(
    $scope: IErrorScope,
    $state: ng.ui.IStateService,
    $stateParams: IErrorStateParams,
    server: ServerService
  ) {
    // attempt to coerce to number
    const error: number = +$stateParams.errorCode;

    let redirectUrl = '';
    let redirectState = '';
    const redirectSiteUrlName = $stateParams.redirectSiteUrlName || server.sessionSiteUrlName();
    const siteUrls = new SpacesSiteUrls({ siteUrlName: redirectSiteUrlName });
    if (!error) {
      if ($stateParams.redirectState) {
        redirectState = $stateParams.redirectState;
      } else {
        redirectUrl = siteUrls.contentRootUrl();
      }

      $scope.redirectLocKey = $stateParams.redirectLocKey || 'backToContent';
      let redirectHrefStateParams;

      if($stateParams.detailsLinkifierModel) {
        $scope.detailsLinkifierModel = () => JSON.parse($stateParams.detailsLinkifierModel);

        // ASSUMPTION. Only place using the `detailsLinkifierModel` is DataAlertErrorStateHelper for user data alerts.
        // With the move to React Router we shouldn't see new usages of ErrrorState, instead reach for RouterError.
        const currentUser = server.sessionUserInfo();
        redirectUrl = siteUrls.userDataAlertsUrl(currentUser.username, currentUser.domainName);
      } else {
        $scope.detailsLocKey = $stateParams.detailsLocKey || 'pageDoesNotExist';
        redirectHrefStateParams = { siteUrlName: redirectSiteUrlName };
      }

      $scope.redirectUrl = redirectUrl || $state.href(redirectState, redirectHrefStateParams);
    } else {
      switch (error) {
        case SolrErrorCode.SolrDisabled:
        case SolrErrorCode.SolrCommunicationError:
          $scope.redirectLocKey = null;
          $scope.redirectUrl = null;
          $scope.detailsLocKey = 'serverDown';
          break;
        default:
          $scope.redirectLocKey = null;
          $scope.redirectUrl = null;
          $scope.detailsLocKey = $stateParams.detailsLocKey || 'pageDoesNotExist';
          break;
      }
    }
  }
}

Module.instance().controller('ErrorCtrl', ErrorCtrl);
